import { render, staticRenderFns } from "./getTokens.vue?vue&type=template&id=60b42a1d&"
import script from "./getTokens.vue?vue&type=script&lang=js&"
export * from "./getTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports